import { Button } from '@journ/ui/button'
import { Checkbox } from '@journ/ui/checkbox'
import { Icons } from '@journ/ui/icons'
import { Popover, PopoverContent, PopoverTrigger } from '@journ/ui/popover'
import type { Table } from '@/libs/table'

type Props<TData> = {
	table: Table<TData>
}

const ColumnVisibility = <TData,>({ table }: Props<TData>) => {
	const toggleableColumns = table
		.getAllLeafColumns()
		.filter(col => col.columnDef.enableHiding !== false && col.id !== 'actions')

	return (
		<Popover>
			<PopoverTrigger asChild>
				<Button variant='outline' size='icon'>
					<Icons.Tune size={18} />
				</Button>
			</PopoverTrigger>
			<PopoverContent className='w-50 p-0' align='end' sideOffset={8}>
				<div className='flex flex-col p-4 space-y-2 max-h-100 overflow-auto'>
					{toggleableColumns.map(column => {
						const meta = column.columnDef.meta as { headerLabel?: string } | undefined
						const label = meta?.headerLabel ?? column.columnDef.header?.toString() ?? column.id
						return (
							<div key={column.id} className='flex items-center space-x-2'>
								<Checkbox
									id={column.id}
									checked={column.getIsVisible()}
									onCheckedChange={checked => column.toggleVisibility(checked === true)}
								/>
								<label
									htmlFor={column.id}
									className='text-sm peer-disabled:cursor-not-allowed peer-disabled:opacity-70'
								>
									{label}
								</label>
							</div>
						)
					})}
				</div>
			</PopoverContent>
		</Popover>
	)
}

export { ColumnVisibility }
